import { connect } from 'react-redux';

// actions
import { openQuitFlowModal } from 'current/uiwidgets';
import { closeMessage } from 'messages';
import { goBack, goForward } from 'script-flow';

// selectors
import { isInitialLoadDone } from 'api/loading/selectors';
import { canGoBack, canGoForward } from './selectors';
import { getActiveField, isExperimentScripting } from 'current/selectors';
import { getAllMessages } from 'messages/selectors';
import { getStepNumber, isLastStep } from 'script-flow/selectors';
import { isAppMode } from 'settings/selectors';

import TrialScript from './TrialScript';

export default connect(
  state => ({
    activeField: getActiveField(state),
    canGoBack: canGoBack(state),
    canGoForward: canGoForward(state),
    initialLoadIsInProgress: !isInitialLoadDone(state),
    isAppMode: isAppMode(state),
    isExperimentScripting: isExperimentScripting(state),
    isFinalStep: isLastStep(state),
    messages: getAllMessages(state),
    stepNumber: getStepNumber(state)
  }),
  dispatch => ({
    closeMessage: id => {
      dispatch(closeMessage(id));
    },
    onClickBack: () => {
      dispatch(goBack());
    },
    onClickForward: () => {
      dispatch(goForward());
    },
    onClickCancel: () => {
      dispatch(openQuitFlowModal());
    }
  })
)(TrialScript);
